// « Dans le même esprit » (sections/snk-related.liquid) : quand la section approche de l'écran, charge les
// recommandations de Shopify (data-url, rendu de la section avec recommendations.performed) et remplace les cartes
// de la liste de secours par celles-ci ; sans recommandation (ou en cas d'erreur), la liste de secours reste.
// La liste est masquée le temps du chargement pour ne pas changer de cartes sous les yeux du visiteur, et le
// remplacement attend qu'aucune carte ne soit en cours d'usage (fenêtre ou feuille des tailles ouverte) : sinon la
// carte touchée disparaît avec sa feuille (vu sur iPhone le 28 oct. 2026).
if (!customElements.get('snk-related')) {
  customElements.define(
    'snk-related',
    class SnkRelated extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-snk-related-list]');
        if (!this.list || !this.dataset.url) return;
        this.classList.add('is-loading');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      // Attend (au plus 30 s) que plus aucune carte de la liste ne soit ouverte ou en train d'ajouter
      async whenIdle() {
        const busy = () => this.list.querySelector('.snk-card.is-open, .snk-qa-sheet[open], [aria-busy="true"], .is-added');
        for (let i = 0; i < 100 && busy(); i++) await new Promise((resolve) => setTimeout(resolve, 300));
      }

      async load() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) throw new Error(response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const list = doc.querySelector('[data-snk-related-list]');
          if (list?.children.length) {
            await this.whenIdle();
            this.list.replaceChildren(...list.children);
          }
        } catch (error) {
          // Pas de recommandation : la liste de secours reste
        }
        this.classList.remove('is-loading');
        // Sans aucune carte (ni recommandation, ni collection), la section disparaît
        this.hidden = !this.list.children.length;
        this.list.dispatchEvent(new Event('scroll'));
      }
    }
  );
}
